import type { ComponentProps } from 'react'

import { BaseCodeInput } from './base-code-input'
import { CodePinPlaceholder } from './code-pin-placeholder'

type Props = { showChars?: boolean } & Omit<
  ComponentProps<typeof BaseCodeInput>,
  'children'
>

export const CodeInput = ({ showChars, ...props }: Props) => {
  const inputs = (unicodedValue: string[], greyLength: number) => {
    const activePins = unicodedValue.map((currChar, index) => (
      <CodePinPlaceholder
        key={`active${index}`}
        data-testid="active-pin"
        readOnly={props.readOnly}
        showValue={showChars}
        value={currChar}
      />
    ))

    const greyPins = Array(greyLength)
      .fill(null)
      .map((s, index) => (
        <CodePinPlaceholder
          key={`placeholder${index}`}
          current={!index}
          data-testid="grey-pin"
        />
      ))

    return [...activePins, ...greyPins]
  }

  return (
    <BaseCodeInput
      data-testid="code-input"
      // allowing only numeric
      formattedOptions={{
        numericOnly: true,
      }}
      // display only numeric keyboard eventhough it's a text input (cleave doesn't support numeric input)
      inputMode="numeric"
      type="text"
      {...props}
    >
      {inputs}
    </BaseCodeInput>
  )
}
